import { Pipe, PipeTransform } from '@angular/core';

import { DecimalConfig } from '../configs';
import { DecimalPlacesUtils } from '../util/decimal-places.utils';

//

@Pipe({
  name: 'decimalPlaces',
})
export class DecimalPlacesPipe implements PipeTransform {
  transform(
    value :string | number,
    places :number = DecimalConfig.defaultPlaces,
  ) :string | number {
    return DecimalPlacesUtils.format(value, places);
  }
}

@Pipe({
  name: 'decimalPlaces',
  standalone: true,
})
export class DecimalPlacesStandalonePipe
  extends DecimalPlacesPipe
  implements PipeTransform {}
